import { createApi } from "../../utils/createApi";
import {
  WireGuardTunnel,
  WireGuardTunnelResponse,
} from "./wireGuardTunnelsInterfaces";

const getRelativeApiPath = (nextUrl: string) => {
  if (!nextUrl.startsWith("http")) {
    return nextUrl;
  }

  try {
    const parsedUrl = new URL(nextUrl);
    const apiSplit = parsedUrl.pathname.split("/api/");
    const relativePath = apiSplit[1] || "";
    return `${relativePath}${parsedUrl.search}`;
  } catch {
    return nextUrl;
  }
};

export const fetchAllWireGuardTunnels = async (): Promise<WireGuardTunnel[]> => {
  const AxiosUI = createApi("");
  const allTunnels: WireGuardTunnel[] = [];
  const visitedUrls = new Set<string>();
  let nextUrl: string | null = "wireguard_tunnel/?all_levels=true";

  while (nextUrl) {
    const relativeUrl = getRelativeApiPath(nextUrl);
    if (visitedUrls.has(relativeUrl)) {
      break;
    }

    visitedUrls.add(relativeUrl);
    const response = await AxiosUI.get<WireGuardTunnelResponse>(relativeUrl);

    allTunnels.push(...(response.data?.results ?? []));
    nextUrl = response.data?.next ?? null;
  }

  return allTunnels;
};
